export const POST_METHOD_NAME: string = 'POST';
export const CORS_MODE_NAME = 'cors';
export const GET_METHOD_NAME: string = 'GET';
export const PUT_METHOD_NAME: string = 'PUT';
export const PATCH_METHOD_NAME: string = 'PATCH';
